import React from 'react'
import './BrandsWork.css'
const BrandsWork = () => {
    return (
        <>
            <section className="section-heading mid_section-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 grident-color-sub-title">
                            <h2 style={{ color: "#D166AF ", fontSize: "31px" }} className="text-center Technology-Stack ">Brands We Have Worked With</h2>
                        </div>
                    </div>
                    <div className="row tech p-5 pt-0 mt-5 mb-0" style={{ display: "flex", justifyContent: "space-between" }}>

                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/haawks.webp" className="w-100 h-40" alt="haawks | metablocktechnologies" />
                            <h5>Haawks</h5>
                        </div>

                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/Dsea.webp" alt="Dsea | metablocktechnologies" className="w-100 h-40" />
                            <h5>Dsea</h5>

                        </div>

                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/Buffy-guffy.webp" alt="Buffy Guffy | metablocktechnologies" className="w-100 h-40" />
                            <h5>Buffy Guffy</h5>
                        </div>


                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/Defilogo.webp" alt="Defi logo | metablocktechnologies" className="w-100 h-40" />
                            <h5>Defi</h5>
                        </div>

                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/ecommerce.webp" alt="Ecommerce website development | metablocktechnologies" className="w-100 h-40" />
                            <h5>Ecommerce</h5>
                        </div>
                    </div>


                    <div className="brands-we-have-worked row tech p-5 pt-0 mt-0 mb-0" style={{ display: "flex", justifyContent: "space-between" }}>

                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/taTrading.webp" alt="Trading guideness | metablocktechnologies" className="w-100 h-40" />
                            <h5>TA Trading</h5>
                        </div>

                        <div className=" col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/analytics.webp" alt="Analytics logo | metablocktechnologies" className="w-100 h-40" />
                            <h5>Analytical</h5>
                        </div>

                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/Donation.webp" alt="Donation | metablocktechnologies" className="w-100 h-40" />
                            <h5>Donation</h5>
                        </div>


                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/zuraverses.webp" alt="Zuraverses | metablocktechnologies" className="w-100 h-40" />
                            <h5>Zuraverses</h5>
                        </div>

                        <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                            <img src="./images/Bookishow.webp" alt="Bookmyshow  logo | metablocktechnologies" className="w-100 h-40" />
                            <h5>Bookishow</h5>
                        </div>
                    </div>



                </div>
            </section>
        </>
    )
}

export default BrandsWork;
